import { createRouter, createWebHistory } from "vue-router";
import { defaultTitle } from "../assets/scripts/config";
import List from "../views/UnitList.vue";
import UnitTitlesJson from "@/assets/json/unit_titles.json";
import LearningUnit01 from "../assets/json/learning_unit_01.json";
import LearningUnit02 from "../assets/json/learning_unit_02.json";
import LearningUnit03 from "../assets/json/learning_unit_03.json";
import LearningUnit04 from "../assets/json/learning_unit_04.json";
import LearningUnit05 from "../assets/json/learning_unit_05.json";
import LearningUnit06 from "../assets/json/learning_unit_06.json";
import LearningUnit07 from "../assets/json/learning_unit_07.json";
import LearningUnit08 from "../assets/json/learning_unit_08.json";
import store from "@/store/index.js";

const { unit_titles } = UnitTitlesJson;

const getUnitTitle = (unitTitles) => {
  const sideMenuTitle = unitTitles.side_menu_title;
  console.log(sideMenuTitle);
  const hasSideMenuTitle = !(
    sideMenuTitle === undefined || sideMenuTitle === ""
  );
  console.log(hasSideMenuTitle);
  return hasSideMenuTitle ? unitTitles.side_menu_title : unitTitles.title;
};

const routes = [
  {
    path: "/",
    name: "List",
    component: List,
    meta: { title: "政治・経済ホーム" },
    props: {
      unitTitlesJson: UnitTitlesJson,
    },
  },
  {
    path: "/a/",
    name: "a",
    component: () =>
      import(/* webpackChunkName: "A" */ "../views/LearningUnit.vue"),
    meta: { title: "第1編第1章 現代日本の政治" },
    props: {
      unitTitle: getUnitTitle(unit_titles[0]),
      learningUnitJson: LearningUnit01,
    },
  },
  {
    path: "/b/",
    name: "b",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "第1編第2章 現代日本の経済" },
    props: {
      unitTitle: getUnitTitle(unit_titles[1]),
      learningUnitJson: LearningUnit02,
    },
  },
  {
    path: "/c/",
    name: "c",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "第1編第3章 現代日本の諸課題の探究" },
    props: {
      unitTitle: getUnitTitle(unit_titles[2]),
      learningUnitJson: LearningUnit03,
    },
  },
  {
    path: "/d/",
    name: "d",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "第2編第1章 現代の国際政治" },
    props: {
      unitTitle: getUnitTitle(unit_titles[3]),
      learningUnitJson: LearningUnit04,
    },
  },
  {
    path: "/e/",
    name: "e",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "第2編第2章 現代の国際経済" },
    props: {
      unitTitle: getUnitTitle(unit_titles[4]),
      learningUnitJson: LearningUnit05,
    },
  },
  {
    path: "/f/",
    name: "f",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "第2編第3章 国際社会の諸課題の探究" },
    props: {
      unitTitle: getUnitTitle(unit_titles[5]),
      learningUnitJson: LearningUnit06,
    },
  },
  {
    path: "/g/",
    name: "g",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "18歳からの社会参加" },
    props: {
      unitTitle: getUnitTitle(unit_titles[6]),
      learningUnitJson: LearningUnit07,
    },
  },
  {
    path: "/h/",
    name: "h",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "参考資料" },
    props: {
      unitTitle: getUnitTitle(unit_titles[7]),
      learningUnitJson: LearningUnit08,
    },
  },
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to) => {
  document.title = to.meta.title || defaultTitle;
});

router.beforeEach(() =>{
  store.commit(
    "toggleDarkMode",
    localStorage.getItem("darkModeFrag") === "true"
  );
});

export default router;
